import React from 'react';

interface SliderNextArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const SliderNextArrow = ({ className, style, onClick }: SliderNextArrowProps) => {
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        background: 'black',
        borderRadius: '50%',
        padding: '10px',
      }}
      onClick={onClick}
    />
  );
};

export default SliderNextArrow;
